import { Component, Input } from '@angular/core';
import { RefdataProvider } from '../../providers/refdata/refdata';
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Generated class for the FaqViewerComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'faq-viewer',
  templateUrl: 'faq-viewer.html',
  styleUrls: ['./faq-viewer.scss'],
  standalone: false
})
export class FaqViewerComponent {
  randomNumber: string;

  public frameheight: number = 600; 

  constructor(public http: HttpClient, private refdata: RefdataProvider) {
    this.randomNumber = '' + performance.now();
    this.log('random number = ' + this.randomNumber);
      this.frameheight = window.innerHeight;
      this.log('frameheight = ' + this.frameheight);
  }
  log(s: string) {
    console.log((new Date()).toString() + ' - faq-viewer - ' + s);
  }

  @Input()
  set randomParam(r) {
    this.randomNumber = r;
  }
  get randomParam() {
    return 'https://www.beerhive.com/faqs_app/?x=' + this.randomNumber;
  }
}